import React from "react";
import PropTypes from "prop-types";
import { useProjectForm } from "../../hooks/useProjectForm";
import ProjectFormView from "./ProjectFormView";

function ProjectFormContainer({ onSuccess, onCancel }) {
    const form = useProjectForm(onSuccess, onCancel);
    return <ProjectFormView {...form} />;
}

export default ProjectFormContainer;

ProjectFormContainer.propTypes = {
    onSuccess: PropTypes.func,
    onCancel: PropTypes.func,
};
